<template>
  <modal
    :visible="visible"
    class="preview"
    title="Notice"
    can-close
    @close="closeModalNotif"
  >
    <template v-slot:body>
      <div class="colorMessage">
        {{ linkForStudio ? 'Media has been processed successfully' : modalData.message }}
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/dialog/Modal.vue";
import { readNotifications } from "@/api/notifications.js";

/** vuex */
import { mapState, mapGetters } from "vuex";

// @group Dialog
// Modal with preview of trimming video
export default {
  name: "Notifications",
  components: {
    Modal
  },
  props: {
    // is modal opened
    visible: {
      type: Boolean,
      default: false
    },
    // preview start time UNIX timestamp
    beginTime: {
      type: Number,
      default: null
    },
    // preview end time UNIX timestamp
    endTime: {
      type: Number,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      /** modals */
      modals: state => state.modals.clipper.MODALS,
      openedModal: state => state.modals.clipper.opened,
      modalData: state => state.modals.clipper.modalData
    }),
    linkSharing() {
      return this.modalData ? JSON.parse(this.modalData.details).link : null;
    },
    linkForStudio() {
      return this.modalData?.link;
    }
  },
  watch: {
    // @vuese
    // Subscribe/unsubscribe on P shortcut
  },
  methods: {
    closeModalNotif() {
      readNotifications();
      this.$emit("close");
    }
  }
};
</script>

<style>
.colorMessage {
  color: white;
}
.colorLink {
  color: white;
}
.preview-player {
  width: 67vw;
}
</style>
